import React from "react";
import ReactDOM from "react-dom";
import "./file_uploader.scss";
import "../theme/survey.scss";
import { Icon, ws_c_cancel, ws_plus } from "../components/icon/icon";
import { translate } from "../lib/intl";
import { Spinner } from "react-activity";
import { colors } from "../theme/theme";
import { onUploadFiles } from "./survey.utils";
import { FabButton } from "../components/button/fab";
import PropTypes from "prop-types";

const ACCEPT_BY_QUESTION_TYPE = {
  picture: "image/*",
  file: "image/*,application/pdf",
};

class UploadComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    let initialFileName = null;
    if (props.question.value) {
      let fileNameStr = String(props.question.value)
        .split("/")
        .pop()
        .split("?")[0];
      try {
        fileNameStr = decodeURIComponent(fileNameStr);
      } catch (e) {}
      initialFileName = fileNameStr.replace(
        /^[A-Za-z0-9_-]{22}__[A-Za-z]{5}_/,
        "",
      );
    }

    this.state = {
      state: props.question.value ? "loaded" : "awaiting", // awaiting, pending, loaded
      file_url: props.question.value ? props.question.value : null,
      accept:
        ACCEPT_BY_QUESTION_TYPE[props.question.accept] ||
        props.question.accept ||
        "image/*,application/pdf",
      file_name: initialFileName,
      error: null,
    };
  }

  _clean() {
    this.setState({
      state: "awaiting",
      file_url: null,
      file_name: null,
      error: null,
    });
    this.props.changeHandler(null);
  }

  _upload(event) {
    event.preventDefault();
    const src = event.target || event.srcElement;

    if (!src.files || src.files.length === 0) {
      return;
    }

    const file = src.files[0];
    const MIN_SIZE = 30; // atleast 30 bytes, minimal size for a valid document or image

    if (file.size < MIN_SIZE) {
      this.setState({
        state: "awaiting",
        file_url: null,
        file_name: null,
        error: "File is too small. Minimum size required is 30 bytes",
      });
      return;
    }

    this.setState({ state: "pending", file_name: file.name, error: null });

    onUploadFiles(null, {
      files: src.files,
      accept: this.state.accept,
      callback: (result) => this._onLoaded(result),
    });
  }

  _onLoaded(result) {
    if (typeof result === "string" && result) {
      this.setState({ state: "loaded", file_url: result, error: null });
      this.props.changeHandler(result);
      return;
    }

    let error = "Invalid upload response";
    if (result && typeof result === "object") {
      error = result.error || "File upload failed. Please try again.";
    } else if (result == null) {
      error = "File upload failed. Please try again.";
    }
    this.setState({
      state: "awaiting",
      file_url: null,
      file_name: null,
      error,
    });
  }

  render() {
    return (
      <div className="fileContainer">
        {this.state.error && (
          <div className="sv_q_erbox">{this.state.error}</div>
        )}
        <div
          className="file_uploader"
          style={
            this.state.state === "loaded"
              ? { backgroundImage: `url(${this.state.file_url})` }
              : {}
          }
        >
          {this.state.state === "awaiting" && (
            <label className="clickable">
              <input
                ref={(ref) => (this.fileInput = ref)}
                type="file"
                style={{ color: "transparent" }}
                onChange={(event) => this._upload(event)}
                aria-label="file"
                multiple={false}
                title="title"
                accept={this.state.accept}
              />
              <div className="icon_upload">
                <Icon icon={ws_plus} size={20} color={colors.coolGray.c4} />
              </div>
              <div className="center xsmall">
                {translate("general.file_upload")}
              </div>
            </label>
          )}

          {this.state.state === "pending" && (
            <Spinner color={colors.coolGray.c4} size={20} speed={1} />
          )}

          {this.state.state === "loaded" && (
            <div className="cancel">
              <FabButton
                title=""
                icon={ws_c_cancel}
                size={20}
                backgroundColor={colors.coolGray.c4}
                onPress={() => this._clean()}
              />
            </div>
          )}
        </div>
        {this.state.state === "loaded" && this.state.file_name && (
          <div className="center xsmall spacer">{this.state.file_name}</div>
        )}
      </div>
    );
  }
}

UploadComponent.propTypes = {
  question: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    accept: PropTypes.string,
  }).isRequired,
  changeHandler: PropTypes.func.isRequired,
};

export function register_widget_file_uploader(Survey) {
  let widget = {
    name: "file_uploader",

    widgetIsLoaded: function () {
      //If the widgets depends on third-party library(s) then here you may check if this library(s) is loaded
      return true;
    },
    isFit: function (question) {
      return question.getType() === "file_uploader";
    },

    activatedByChanged: function (activatedBy) {
      //We are creating a new class and derived it from text question type. It means that text model (properties and fuctions) will be available to us
      Survey.JsonObject.metaData.addClass("file_uploader", [], null, "empty");
      Survey.JsonObject.metaData.addProperties("file_uploader", [
        {
          name: "accept:string",
          default: "picture",
          choices: ["picture", "file"],
        },
      ]);
    },

    afterRender: function (question, el) {
      let rendering = (
        <UploadComponent
          question={question}
          changeHandler={(value) => (question.value = value)}
        />
      );
      ReactDOM.render(rendering, el);
    },

    //If you want to use the default question rendering then set this property to true. We do not need any default rendering, we will use our our htmlTemplate
    htmlTemplate: "<div style='padding: 0 20px'></div>",
  };

  // register widget
  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, "customtype");
}
